import React, { useContext } from 'react';
import { styled } from '@mui/material';

import { Box, Button, Form, PasswordInput, Stack, Text } from 'shell/components';
import { PageContext } from 'pages/ForgotPasswordPage/PageProvider';

const NewPassword = ({ device, errors, form, satisfyRequirement, handleChange, handleUpdatePassword }) => {
    const { loading } = useContext(PageContext);
    return (
        <VerifyEmailBox device={device}>
            <Stack alignItems={'center'}>
                <Text variant={'h6'}>Verification Code Sent!</Text>
            </Stack>
            <Form onSubmit={() => handleUpdatePassword()}>
                <InputStack spacing={6}>
                    <PasswordInput
                        data-cy={'forgot-password-new-input'}
                        error={Boolean(errors.password)}
                        helperText={errors.password}
                        label={'Enter New Password'}
                        value={form.password}
                        onChange={(e) => handleChange('password', e.target.value)}
                        placeholder={'Enter new password'}
                        autoComplete={'new-password'}
                        required
                    />

                    <Stack sx={{ margin: (theme) => theme.spacing(2, 0, 6, 0) }}>
                        <Text variant={'p3'}>The password must have:</Text>
                        <Text variant={'p3'} color={satisfyRequirement.validateMoreThan8Characters ? 'error' : 'light'}>
                            • At leaset 8 characters
                        </Text>
                        <Text variant={'p3'} color={satisfyRequirement.validateOneLowerCase ? 'error' : 'light'}>
                            • At least one lowercase letter
                        </Text>
                        <Text variant={'p3'} color={satisfyRequirement.validateOneUpperCase ? 'error' : 'light'}>
                            • At least one uppercase letter
                        </Text>
                        <Text variant={'p3'} color={satisfyRequirement.validateOneNumber ? 'error' : 'light'}>
                            • At least one number
                        </Text>
                        <Text variant={'p3'} color={satisfyRequirement.validateOneSpecial ? 'error' : 'light'}>
                            • At least one special character
                        </Text>
                    </Stack>
                    <PasswordInput
                        data-cy='forgot-password-confirm-input'
                        error={Boolean(errors.confirmPassword)}
                        helperText={errors.confirmPassword}
                        label={'Confirm Password'}
                        value={form.confirmPassword}
                        onChange={(e) => handleChange('confirm-password', e.target.value)}
                        placeholder={'Enter new password'}
                        autoComplete={'new-password'}
                        required
                    />
                </InputStack>
                <Stack sx={{ margin: (theme) => theme.spacing(6, 0, 3, 0) }}>
                    <Button data-cy={'forgot-password-change-password-button'} loading={loading} type={'submit'}>
                        Change Password
                    </Button>
                </Stack>
            </Form>
        </VerifyEmailBox>
    );
};

const VerifyEmailBox = styled(Box)(({ theme, device }) => {
    return {
        marginTop: theme.spacing(12),
        padding: theme.spacing(7),
        width: device === 'mobile' ? '100%' : 450,
        height: 'fit-content',
        background: device === 'mobile' ? 'transparent' : theme.palette.ensightful.shades[0],
        boxShadow: device === 'mobile' ? 'none' : theme.palette.ensightful.shadows[1],
        borderRadius: '12px',
    };
});

const InputStack = styled(Stack)(({ theme }) => {
    return {
        margin: theme.spacing(6, 0, 2, 0),
    };
});

export default NewPassword;
